import React, { useEffect } from 'react';
import { useParams, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { postCmsCoachingCoursePublish, postCmsCoachingPublish } from "../../../../store/actions/cms/cmsCoaching";

function UnPublish() {
  const { id, courseId } = useParams();
  const navigate = useNavigate()
  const dispatch = useDispatch()
  const user = useSelector((state) => state?.userData?.user?.data);
  const { coursePublishLoading, coachingPublishLoading, coursePublish, coachingPublish, coachingPublishError, coursePublishError } = useSelector((state) => state?.cmsCoaching)
  useEffect(() => {
    let params = {};
    params.user_id = user.id;
    params.action = "unpublish"
    if (courseId) {
      params.id = courseId;
      params.page = "course";
      dispatch(postCmsCoachingCoursePublish(params))
    } else if (id) {
      params.id = id;
      params.page = "coaching";
      dispatch(postCmsCoachingPublish(params))
    }
    return () => {
      dispatch({ type: 'CLEAR_COURSE_PUBLISH' })
      dispatch({ type: 'CLEAR_COACHING_PUBLISH' })
    }
  }, [])

  useEffect(() => {
    if (coursePublish || coachingPublish || coursePublishError || coachingPublishError) {
      setTimeout(() => {
        navigate(-1)
      }, 2000)
    }
  }, [coursePublish || coachingPublish || coursePublishError || coachingPublishError])



  return (
    <div className={"permission_denied"}>
      {(coursePublishLoading || coachingPublishLoading) ?
        <>
          {coachingPublishLoading && <h1>Unpublishing Coaching...</h1>}
          {coursePublishLoading && <h1>Unpublishing Course...</h1>}
        </>
        :
        <>
          {(coursePublish || coachingPublish) &&
            <div>
              <h1>Unpublished Successfully</h1>
              <h5>Thank You!</h5>
            </div>}

          {(coursePublishError || coachingPublishError) &&
            <div className='text-danger'>
              <h1>Failed to Unpublish</h1>
              <h5>Please try again</h5>
            </div>}
        </>}
    </div>
  )
}

export default UnPublish;